import React, { useState, useEffect } from "react";
import supportChatQIcon from "../../../assets/images/supportChatQIcon.svg";
import supportChatCrossIcon from "../../../assets/images/supportChatCrossIcon.svg";
import supportChatIcon from "../../../assets/images/supportChatIcon.svg";
import supportChatDownIcon from "../../../assets/images/supportChatDownIcon.svg";
import socialLinks from "../../../config/socialsLinks";

const Faqs = (props) => {
  const { faqsData } = props;
  const [contactView, setContactView] = useState(false);

  const showContectDetails = () => {
    let getWidth = document.body.offsetWidth <= 992 ? true : false;
    let faq_contactBox = document.querySelector(".faq_contactBox").style;
    if (getWidth) {
      if (contactView) {
        faq_contactBox.display = "block";
      } else {
        faq_contactBox.display = "none";
      }
    }
  };

  useEffect(() => {
    showContectDetails();
  }, [contactView]);

  return (
    <div className="faq_container">
      <div className="faqBox">
        {faqsData &&
          faqsData.qa &&
          faqsData.qa.map((faq) => {
            return (
              <div key={faq.id} className="faq_wrap">
                <h4>{faq.question}</h4>
                {/* <p>{faq.emtAnswer}</p> */}
                <p dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
              </div>
            );
          })}
      </div>
      <div className="faq_contactBox">
        <div className="contactView">
          <span>For queries</span>
          <div className="faq_contactBox_content">
            <p>Contact us at</p>
            <h6>1800 - 102 - 3335</h6>
            <p>Weekdays 09AM - 06PM</p>
          </div>
          <div className="faq_contactBox_content">
            <p>Write to us on</p>
            <h6>
              <a href={`mailto:${socialLinks.apiConnectMail}`}>
                {socialLinks.apiConnectMail}
              </a>
            </h6>
          </div>
        </div>
      </div>
      <div
        className="contect_icon_tab"
        onClick={() => setContactView(!contactView)}
      >
        {contactView ? (
          <img src={supportChatDownIcon} alt="Chat support icon" />
        ) : (
          <img src={supportChatIcon} alt="Chat support icon" />
        )}
      </div>
      <div
        className="contect_icon_mob"
        onClick={() => setContactView(!contactView)}
      >
        {contactView ? (
          <img src={supportChatCrossIcon} alt="Chat support icon" />
        ) : (
          <img src={supportChatQIcon} alt="Chat support icon" />
        )}
      </div>
    </div>
  );
};

export default Faqs;
